import { ArrowLeft } from "lucide-react";

export const inp = "w-full bg-transparent border border-white/15 focus:border-[color:var(--bl-blue)] outline-none px-3 py-2.5 text-white font-mono text-sm placeholder:text-white/30";

const FIELDS = [
  { key: "full_name", testid: "ship-name", placeholder: "Full name", required: true },
  { key: "email", testid: "ship-email", placeholder: "Email", required: true, type: "email" },
  { key: "phone", testid: "ship-phone", placeholder: "Phone (optional)" },
  { key: "line1", testid: "ship-line1", placeholder: "Address line 1", required: true },
  { key: "line2", testid: "ship-line2", placeholder: "Address line 2 (optional)" },
];

export function ShippingForm({ ship, setShip, onBack }) {
  const set = (key, transform = v => v) => e => setShip({ ...ship, [key]: transform(e.target.value) });
  return (
    <div className="space-y-3">
      <button onClick={onBack} className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-white/50 hover:text-white mb-2"><ArrowLeft size={12} /> Back</button>
      {FIELDS.map(f => (
        <input key={f.key} data-testid={f.testid} type={f.type} required={f.required} value={ship[f.key]} onChange={set(f.key)} placeholder={f.placeholder} className={inp} />
      ))}
      <div className="grid grid-cols-2 gap-2">
        <input data-testid="ship-city" required value={ship.city} onChange={set("city")} placeholder="City" className={inp} />
        <input data-testid="ship-state" required value={ship.state} onChange={set("state")} placeholder="State" className={inp} />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <input data-testid="ship-postcode" required value={ship.postcode} onChange={set("postcode")} placeholder="Postcode" className={inp} />
        <input data-testid="ship-country" required value={ship.country} onChange={set("country", v => v.toUpperCase().slice(0, 2))} placeholder="Country" className={inp} />
      </div>
    </div>
  );
}
